// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1RJLJ","right":"styles_right__1anQ9"};